import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd5a05fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page404" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"face\" data-v-dd5a05fe><div class=\"band\" data-v-dd5a05fe><div class=\"red\" data-v-dd5a05fe></div><div class=\"white\" data-v-dd5a05fe></div><div class=\"blue\" data-v-dd5a05fe></div></div><div class=\"eyes\" data-v-dd5a05fe></div><div class=\"dimples\" data-v-dd5a05fe></div><div class=\"mouth\" data-v-dd5a05fe></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('notFound.text')), 1),
    _createVNode(_component_router_link, {
      to: _ctx.link,
      class: "btn"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('notFound.btn')), 1)
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}